import type { DatesSetArg } from '@fullcalendar/core';
import { format, isSameMonth, subDays } from 'date-fns';
import type { CalendarViewMode } from '@/types/calendarTypes';

export function formatWeekRangeLabel(weekStart: Date, weekEnd: Date): string {
  if (isSameMonth(weekStart, weekEnd)) {
    return `${format(weekStart, 'MMM d')} – ${format(weekEnd, 'd, yyyy')}`;
  }
  return `${format(weekStart, 'MMM d, yyyy')} – ${format(weekEnd, 'MMM d, yyyy')}`;
}

export function formatCalendarNavTitle(
  view: CalendarViewMode,
  anchorDate: Date,
  weekStart: Date,
  weekEnd: Date
): string {
  if (view === 'day') {
    return format(anchorDate, 'EEEE, MMMM d, yyyy');
  }
  if (view === 'week') {
    return formatWeekRangeLabel(weekStart, weekEnd);
  }
  return format(anchorDate, 'MMMM, yyyy');
}

export function getVisibleCalendarRange(arg: DatesSetArg): { start: string; end: string } {
  return {
    start: format(arg.start, 'yyyy-MM-dd'),
    end: format(subDays(arg.end, 1), 'yyyy-MM-dd'),
  };
}
